/**
 * Occupied vs. vacant, as a single part-to-whole bar. Two categories, so this
 * is identity, not magnitude — `--up`/`--down` are this app's existing status
 * pair (current/late elsewhere, per WidgetIcon's own doc comment), reused
 * here for the same "good/needs attention" meaning rather than inventing a
 * second color pair for the same idea. The count renders inside a segment
 * wide enough to hold it; a small vacancy share (the common case) is too
 * narrow for that, so the swatch legend underneath is the reliable label,
 * not decoration.
 */

export function OccupancyBar({ occupied, vacant }: { occupied: number; vacant: number }) {
  const total = Math.max(1, occupied + vacant);
  const occupiedPct = (occupied / total) * 100;
  const vacantPct = 100 - occupiedPct;

  return (
    <div>
      <div className="occupancy-bar">
        {occupied > 0 ? (
          <span
            className="occupancy-bar__segment"
            style={{ width: `${occupiedPct}%`, background: 'var(--up)' }}
            title={`Occupied: ${occupied}`}
          >
            {occupiedPct >= 18 ? occupied : null}
          </span>
        ) : null}
        {vacant > 0 ? (
          <span
            className="occupancy-bar__segment"
            style={{ width: `${vacantPct}%`, background: 'var(--down)' }}
            title={`Vacant: ${vacant}`}
          >
            {vacantPct >= 18 ? vacant : null}
          </span>
        ) : null}
      </div>
      <div className="row occupancy-bar__legend">
        <span className="muted">
          <span className="occupancy-bar__swatch" style={{ background: 'var(--up)' }} /> Occupied (
          {occupied})
        </span>
        <span className="muted">
          <span className="occupancy-bar__swatch" style={{ background: 'var(--down)' }} /> Vacant (
          {vacant})
        </span>
      </div>
    </div>
  );
}
